import React, {useMemo} from 'react';
import DashCard from "./dash-card.jsx";
import useGraphViewportWidth from "../../../../hooks/use-graph-viewport-width.js";
import {fluidPx} from "../../../../utils/responsive-graph.js";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const VEHICLE_ICONS = {
    bicycle: getAssetPath("/img/dashboard-svg/dash-bicycle.svg"),
    car: getAssetPath("/img/dashboard-svg/dash-car.svg"),
    truck: getAssetPath("/img/dashboard-svg/dash-truck.svg"),
    motorcycle: getAssetPath("/img/dashboard-svg/dash-motorcycle.svg"),
    bus: getAssetPath("/img/dashboard-svg/dash-bus.svg"),
    foot: getAssetPath("/img/dashboard-svg/dash-foot.svg"),
    ship: getAssetPath("/img/dashboard-svg/dash-ship.svg"),
    aircraft: getAssetPath("/img/dashboard-svg/dash-aircraft.svg")
};

const VEHICLE_TYPES = {
    bicycle: ["Bicicleta"],
    car: ["Automóvel", "Caminhonete", "Camioneta", "Carro Elétrico", "Quadriciclo", "Guincho"],
    truck: ["Caminhão"],
    motorcycle: ["Motocicleta"],
    bus: ["Micro-ônibus", "Ônibus", "Utilitário", "Van"],
    foot: ["A pé"],
    ship: ["Embarcação"],
    aircraft: ["Aeronave"]
};

const VEHICLE_LABELS = Object.fromEntries(
    Object.entries(VEHICLE_TYPES).map(([key, types]) => [key, types.join(", ")])
);

const TYPE_TO_GROUP = Object.entries(VEHICLE_TYPES).reduce((groups, [key, types]) => {
    types.forEach(type => { groups[type] = key; });
    return groups;
}, {});

const DutyVehicleType = ({data}) => {
    const vw = useGraphViewportWidth();
    const iconSize = fluidPx(16, 34, vw);

    const vehicles = useMemo(() => {
        const totals = Object.fromEntries(
            Object.keys(VEHICLE_TYPES).map(key => [key, 0])
        );

        Object.entries(data || {}).forEach(([type, count]) => {
            const group = TYPE_TO_GROUP[type];
            if (group) totals[group] += count;
        });

        return Object.entries(totals)
            .sort((a,b) => b[1] - a[1] || VEHICLE_LABELS[a[0]].localeCompare(VEHICLE_LABELS[b[0]], "pt-BR"))
            .slice(0, 4)
    }, [data]);

    return (
        <>
            <h3 className={"mb-1.5! shrink-0 text-center text-(length:--font-md)! text-[#AAAAAA]"}>Tipos de veículo</h3>
            <div className={"grid grid-cols-4 gap-(--dash-gap-sm) min-h-0 flex-1 px-(--dash-pad-lg)"}>
                {
                    vehicles.map(([key, count]) => (
                        <DashCard
                            className={"grid grid-rows-2 justify-items-center items-center p-(--dash-pad-sm)!"}
                            key={`vehicle-type-${key}`}
                            title={VEHICLE_LABELS[key]}
                        >
                            <div className={"flex items-center justify-center"}>
                                <img src={VEHICLE_ICONS[key]} style={{height: iconSize}} alt={key}/>
                            </div>
                            <p className={"text-center m-0! text-(length:--font-sm)!"}>{count}</p>
                        </DashCard>
                    ))
                }
            </div>
        </>
    );
};

export default DutyVehicleType;
